import React from 'react'
import * as R from 'ramda'
import { StepProps } from '../../Step'
import { DesktopStepTitle } from './DesktopStepTitle'
import { MobileStepTitle } from './MobileStepTitle'
import { useIsMobile } from '../../../../hooks/useIsMobile'

export type StepTitleProps = {
  disabled?: boolean
  type: 'complete' | 'current' | 'upcoming' | 'error'
  title: string
  stepNumber: number
  isLast?: boolean
  onClick: () => void
}

type Props = {
  currentStep: number
  stepPropsList: StepProps[]
  onClickTitle: (stepIndex: number) => void
}
export const StepperHeader = (props: Props) => {
  const isMobile = useIsMobile()

  const getTitleState = (titleIndex: number): StepTitleProps['type'] => {
    const stepProps = props.stepPropsList[titleIndex]
    if (stepProps?.errors?.length) return 'error'
    if (props.currentStep === titleIndex) return 'current'
    if (props.stepPropsList[titleIndex]?.completed) return 'complete'
    return 'upcoming'
  }

  const disabled = (index: number, titleProps: StepProps) => {
    const currentStepProps = props.stepPropsList[props.currentStep]
    const state = getTitleState(index)
    if (state === 'complete') return false
    if (currentStepProps?.disabled) return true
    if (titleProps?.errors?.length) return false
    if (currentStepProps?.errors?.length) return true
    if (index < props.currentStep) return false
    if (props.stepPropsList[index]?.disabled) return false
    if (index !== props.currentStep + 1) return true
    return false
  }

  return (
    <header className='w-full border-b flex h-16 grow-0'>
      {isMobile && (
        <nav
          className='flex items-center justify-between sm:hidden px-4 sm:justify-center sm:px-0 h-full w-full'
          aria-label='Progress'>
          <span className='text-md font-semibold text-indigo-600'>
            {props.stepPropsList[props.currentStep]?.title}
          </span>
          <ol role='list' className='flex items-center space-x-5'>
            {props.stepPropsList.map((stepProps, i) => (
              <MobileStepTitle
                key={i}
                title={stepProps.title}
                onClick={() => props.onClickTitle(i)}
                stepNumber={i + 1}
                type={getTitleState(i)}
              />
            ))}
          </ol>
        </nav>
      )}

      {!isMobile && (
        <nav className='h-full w-full max-h-full px-2'>
          <ol className='flex w-full space-x-2 h-full min-w-full justify-evenly'>
            {props.stepPropsList.map((stepProps, index) => (
              <DesktopStepTitle
                key={index}
                disabled={disabled(index, stepProps)}
                title={stepProps.title}
                type={getTitleState(index)}
                stepNumber={index + 1}
                onClick={() => props.onClickTitle(index)}
                isLast={R.equals(R.last(props.stepPropsList), stepProps)}
              />
            ))}
          </ol>
        </nav>
      )}
    </header>
  )
}
